﻿"use strict"

import "../extend/date.js";
import { ClassGrouper}  from "../class-grouper.js";
import { sortObjectArray }  from "../util.js";

export class Subst {

   constructor(app) {
      this.app = app;
      this.dm = app.dm;
      this.settings = app.settings;
      this.sort = { dir: 1 };
      this.defSort();
   }

   setupSubst(substData, watches) {

      const setupData = {};

      // Ungenutzte Präsenzstunden entfernen
      for (const date in substData) {
         const substList = substData[date].filter(subst => {
            return !(subst.old.absentClasses && subst.old.absentClasses.length === 1 && ['P1', 'P2', 'P3'].includes(subst.old.absentClasses[0]))
         });
         if (substList.length) setupData[date] = substList;
      }

      // Aufsichten hinzufügen
      watches.filter(w => w.type !== 'regular').forEach(w => {
         if (setupData.hasOwnProperty(w.date)) {
            setupData[w.date].push(w);
         }
         else {
            setupData[w.date] = [w];
         }
      });

      return setupData;


   }

   loadSubst(data, tab, watches = []) {

      let elContent = tab.querySelector('.main-content');
      elContent = elContent.parentNode.removeChild(elContent);

      let statusbar = tab.querySelector('.statusbar');

      let lastChange = localStorage.getItem('lastUpdateSubstitutions');
      statusbar.querySelector('.time').innerHTML = lastChange ? new Date(parseInt(lastChange)*1000).format("%d.%m.%Y %H:%i:%s Uhr") : '-';

      let elMessage = elContent.querySelector('.message');
      let elTable   = elContent.querySelector('.subst');
      let elTicker  = elContent.querySelector('.ticker');

      data = this.setupSubst(data, watches);
      
      let hasSubst = Object.keys(data).length !== 0;
      elTable.querySelectorAll('tbody tr.new-day, tbody tr.subst-row').forEach(item => item.remove());

      elMessage.hidden = hasSubst;
      elTable.hidden   = !hasSubst;

      this.dm.getTicker().then(data => {
         elTicker.style.display = data.length === 0 ? 'none' : 'block';
         elTicker.innerHTML = data;
      });

      if (hasSubst) {

         const dates = Object.keys(data).sort();

         for (let i of dates) elTable.querySelector('tbody').innerHTML += this.formatDay(data[i]);

         elTable.querySelectorAll('th').forEach(elTh => elTh.classList.remove('sort-desc', 'sort-asc'));
         let th = elTable.querySelector('th[sort="'+this.dm.clientSettings.get('subst.sort.current', 'teacher')+'"]');

         if (this.dm.clientSettings.get('subst.sort.dir', 1) === 1) {
            th.classList.remove('sort-desc')
            th.classList.add('sort-asc');
         }
         else {
            th.classList.remove('sort-asc')
            th.classList.add('sort-desc');
         }

         let sortableHeads = elTable.querySelectorAll('th.teacher, th.hour, th.class, th.room');
         sortableHeads.forEach(item => item.addEventListener('click', (event) => {
            this.dm.clientSettings.set('subst.sort.current', event.target.getAttribute('sort'), true);
            this.dm.clientSettings.set('subst.sort.dir',     event.target.classList.contains('sort-asc') ? -1: 1, true);
            this.loadTab(tab);
         }));

      }

      tab.appendChild(elContent);      
      tab.setAttribute('loaded', true);
      tab.hidden = false;

   }

   loadTab(tab) {

      if (tab.classList.contains("subst-all")) {
         this.loadAll();
      }
      else {
         this.loadMy();
      }
   }

   async loadMy() {

      this.classGrouper = new ClassGrouper(Object.values(this.dm.getCurrentYear().classes));

      let tab = document.querySelector('.main-item[tab-name="subst-my"]');
      let userData = this.dm.getUserSelf();

      let myData = false;
      if (userData.type === 'teacher') myData = await this.dm.getSubstByUser(userData.short.toUpperCase(), this.sort[this.dm.clientSettings.get('subst.sort.current', 'teacher')], true);
      else myData = await this.dm.getSubstByClass(userData.class.name, this.sort[this.dm.clientSettings.get('subst.sort.current', 'teacher')], true);

      const watches = await this.dm.getWatchesByTeacher(userData.id);

      try {
         this.loadSubst(myData, tab, watches);
      }
      catch (e) {
         logger.error(e);
         toast.alert(e, { duration: 8000 });
      };

      if (userData.type === 'pupil') {
         let now = new Date();
         let date1 = now.isoDate();
         for (let i=0; i<3; ++i) now.nextDay([0,1,2,3,4]);
         let date2 = now.isoDate();
         this.dm.sinRequest({ action: 'classnote-get-current', classId: userData.class.id }).then(response => {
            let notes = response.data;

            sortObjectArray(notes, ['<.dateFrom', '<.dateTo']);

            const elItems = tab.querySelector('.main-content .class-notes');
            elItems.empty();

            for (const item of notes) {
               const datePeriod = Date.simplifyDatePeriod(item.dateFrom, item.dateTo);
               if (item.type === 'classNote') {
                  let classes = {};
                  for (const cl of item.classes) classes[cl] = cl;
                  const elItem = elItems.createElement('div', 'class-note-item');
                  elItem.innerHTML = '<div class="content"><span class="date">' + datePeriod + '</span><span class="classes">' + this.classGrouper.group(classes) + '</span><span class="message">' + item.note + '</span>'
                                 + '<span class="creator">' + this.dm.getUser(item.creatorId).short + '</span></div>';
               }
               else {
                  const elItem = elItems.createElement('div', 'class-note-item');
                  const icons = { 'smartphoneViolation': '📱', 'reprimand': '⚠️'};
                  const icon = item.type in icons ? icons[item.type] : '';

                  elItem.innerHTML = `
                     <div class="content">
                        ${icon}
                        <span class="date">${datePeriod}</span>
                        <span class="classes">${userData.firstName} ${userData.lastName}</span>
                        <span class="message">${item.note}</span>
                        <span class="creator">${this.dm.getUser(item.creatorId).short}</span>
                     </div>
                  `;
               }
            }

         });
      }

   }

   loadAll() {

      let tab = document.querySelector('.main-item[tab-name="subst-all"]');
      this.dm.getSubstAll(this.sort[this.dm.clientSettings.get('subst.sort.current', 'teacher')], true)
      .then(data => this.loadSubst(data, tab))
      .catch(e => {
         logger.error(e);
         toast.alert(e, { duration: 8000 });
      });

   }

   formatDay(data) {
      if (data.length == 0) return '';
      let day = '';
      if (data[0].hasOwnProperty('old')) {
         day = '<tr class="new-day"><td colspan="6">' +data[0].old.displayDate+ '.</td></tr>'
      }
      else {
         day = '<tr class="new-day"><td colspan="6">' +Date.fromString(data[0].date).toGermanDate(true, true).beforeLast('.')+ '.</td></tr>'
      }
      day += this.formatSubst(data, 'all');
      return day;

   }

   formatSubst(data, type) {

      const watchPositions = ['vor 1.', '1. Pause', '2. Pause', 'nach 6.'];

      let rows = '';
      let cnt = 0;
      for (let subst of data) {
         // Vertretung
         if (subst.hasOwnProperty('old')) {
            const item = subst.old;

            if (Array.isArray(item.teachers) && item.teachers.equals(item.absentTeachers) && !item.newTeachers  && item.type !== 'CANCELLED') {
               //console.log(subst);
               item.type = 'CANCELLED';
            }

            if (item.absentClasses && item.absentClasses.length === 1 && ['P1', 'P2', 'P3'].includes(item.absentClasses[0])) continue;

            let row = { teacher: '', hour: '', class: '', subject: '', room: '', info: '' };
            let rowClass = ['subst-row'];

            if (item.type == "MOVED_TO" || item.type == "CANCELLED") {
               rowClass.push('cancelled');
            }
            if (cnt % 2 != 0) rowClass.push("even");


            if (item.newTeachers !== undefined)    row.teacher = '<span class="new-teachers">' + item.newTeachers.join(',') + '</span>';
            else if (item.teachers !== undefined)  row.teacher = '<span class="teachers">' + item.teachers.join(',') + '</span>';
            else row.teacher = "?";

            if (!["CANCELLED", "MOVED_FROM"].includes(item.type) && item.absentTeachers !== undefined) {
               row.teacher += ' <span class="absent-teachers">' + item.absentTeachers.join(',') + '</span>';
            }

            if (item.oldHour !== undefined && (item.type != "MOVED_FROM" || item.date == item.oldDate)) {
               row.hour = '<span class="new-hours">' + item.hour + '</span> <span class="absent-hours">' + item.oldHour + '</span>';
            }
            else row.hour = '<span class="hours">' + item.hour + '</span>';


            if (item.newSubjects !== undefined) {
               row.subject = '<span class="new-subjects">' + item.newSubjects + '</span>';
               if (row.subject) row.subject += ' <span class="absent-subjects">' + item.subject + '</span>';
            }
            else row.subject = '<span class="subject">' + item.subject + '</span>';

            if (item.rooms !== undefined) row.room = '<span class="rooms">' + item.rooms.join(', ') + '</span> ';
            row.room = row.room.replace(/<span class="rooms">([^ ,<>]+), ([^ ,<>]+)<\/span>/, '<span class="rooms">$1</span> <span class="absent-rooms">$2</span>');
            if (item.newRooms !== undefined) row.room = '<span class="new-rooms">' + item.newRooms.join(', ') + '</span> ';
            if (item.absentRooms !== undefined) row.room += ' <span class="absent-rooms">' + item.absentRooms.join(', ') + '</span> ';

            row.class = item.classes.join(', ');

            rows += '<tr class="' + rowClass.join(' ') + '"><td class="teacher">' + row.teacher + '</td><td class="hour">' + row.hour + '</td><td class="class">' + row.class + '</td><td class="subject">' + row.subject + '</td><td class="room">' + row.room + '</td><td class="info"><span class="info">' + (item.info == undefined ? '' : item.info) + '</span></td></tr>';

         }
         // Aufsicht
         else {
            let rowClass = ['subst-row'];
            if (subst.type === "remove") rowClass.push('cancelled');
            if (cnt % 2 != 0) rowClass.push("even");
            rows += `<tr class="${rowClass.join(' ')}"><td class="teacher">${this.dm.getUser(subst.teacherId).short}</td><td class="hour">${watchPositions[subst.position]}</td><td class="class"></td><td class="subject">Aufsicht</td><td class="room">${subst.name}</td><td class="info"><span class="info">${subst.note}</span></td></tr>`;

         }

         cnt++;

      }

      return rows;

   }

   loadTagesplaene() {

      let lastChange = localStorage.getItem('lastUpdateSubstitutions');
      document.querySelector('.main-item.tagesplaene .statusbar .time').innerHTML = lastChange ? new Date(parseInt(lastChange)*1000).format("%d.%m.%Y %H:%i:%s Uhr") : '-';

      this.dm.getTagesplaene()
      .then(tagesplaene => {

         tagesplaene = Object.values(tagesplaene).sort((a,b) => a[0].date < b[0].date ? -1 : 1);

         let node = document.querySelector('.main-item.tagesplaene .main-content');
         node.empty();

         for (let tpl of tagesplaene) {
            if (!tpl.length) continue;
            const date = tpl[0].date;
            const elTpl = node.createElement("div", "tagesplan-button");
            node.createElement("div", "tagesplan-panel");
            elTpl.innerHTML = new Date(Date.fromString(date)).toGermanDate(true, true);
            elTpl.accordion({onOpening: async (button, panel) => {
               panel.innerHTML = '';
               for (let plan of tpl) {
                  panel.innerHTML += '<img src="data:image/svg+xml;base64,' + plan.data + '">'
               }
               setTimeout(() => { panel.parentElement.style.maxHeight = panel.parentElement.scrollHeight + "px";}, 500);
            }});
         }
      })
      .catch(e => {
         logger.error(e);
         toast.alert(e, { duration: 8000 });
      })
   }

   defSort() {

      //let sortSettings = this.settings.subst.sort;
      let sortDir = this.dm.clientSettings.get('subst.sort.dir', 1);

      this.sort = {
         teacher: function(a,b) {
            if (a.old.date < b.old.date) return -1;
            if (a.old.date > b.old.date) return 1;

            let aTeacher = '';
            if (a.old.newTeachers !== undefined && a.old.newTeachers.length != 0) aTeacher = a.old.newTeachers[0];
            else if (a.old.teachers !== undefined && a.old.teachers.length != 0) aTeacher = a.old.teachers[0];

            let bTeacher = ''
            if (b.old.newTeachers !== undefined && b.old.newTeachers.length != 0) bTeacher = b.old.newTeachers[0];
            else if (b.old.teachers !== undefined && b.old.teachers.length != 0) bTeacher = b.old.teachers[0];

            if (aTeacher < bTeacher) return -1 * sortDir;
            if (aTeacher > bTeacher) return 1 * sortDir;

            if (a.old.hour < b.old.hour) return -1 * sortDir;
            if (a.old.hour > b.old.hour) return 1 * sortDir;

            return 0;
         },

         hour: function(a,b) {
            if (a.old.date < b.old.date) return -1;
            if (a.old.date > b.old.date) return 1;

            if (a.old.hour < b.old.hour) return -1 * sortDir;
            if (a.old.hour > b.old.hour) return 1 * sortDir;

            let aTeacher = '';
            if (a.old.newTeachers !== undefined && a.old.newTeachers.length != 0) aTeacher = a.old.newTeachers[0];
            else if (a.old.teachers !== undefined && a.old.teachers.length != 0) aTeacher = a.old.teachers[0];

            let bTeacher = ''
            if (b.old.newTeachers !== undefined && b.old.newTeachers.length != 0) bTeacher = b.old.newTeachers[0];
            else if (b.old.teachers !== undefined && b.old.teachers.length != 0) bTeacher = b.old.teachers[0];

            if (aTeacher < bTeacher) return -1 * sortDir;
            if (aTeacher > bTeacher) return 1 * sortDir;

            return 0;
         },

         class: function(a,b) {
            if (a.old.date < b.old.date) return -1;
            if (a.old.date > b.old.date) return 1;

            if (a.old.classSortKey < b.old.classSortKey) return -1 * sortDir;
            if (a.old.classSortKey > b.old.classSortKey) return 1 * sortDir;

            if (a.old.hour < b.old.hour) return -1 * sortDir;
            if (a.old.hour > b.old.hour) return 1 * sortDir;

            let aTeacher = '';
            if (a.old.newTeachers !== undefined && a.old.newTeachers.length != 0) aTeacher = a.old.newTeachers[0];
            else if (a.old.teachers !== undefined && a.old.teachers.length != 0) aTeacher = a.old.teachers[0];

            let bTeacher = ''
            if (b.old.newTeachers !== undefined && b.old.newTeachers.length != 0) bTeacher = b.old.newTeachers[0];
            else if (b.old.teachers !== undefined && b.old.teachers.length != 0) bTeacher = b.old.teachers[0];


            if (aTeacher < bTeacher) return -1 * sortDir;
            if (aTeacher > bTeacher) return 1 * sortDir;

            return 0;
         },

         room: function(a,b) {
            if (a.old.date < b.old.date) return -1;
            if (a.old.date > b.old.date) return 1;

            if (a.old.roomSortKey < b.old.roomSortKey) return -1 * sortDir;
            if (a.old.roomSortKey > b.old.roomSortKey) return 1 * sortDir;
            return 0;
         }
      }

   };

};
